"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichContentText = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const RichContentText = ({ children, bold, italic, color, fontSize }) => {
    if (typeof children !== 'string') {
        return null;
    }
    return (react_1.default.createElement(styles_1.StyledSpan, { bold: bold, italic: italic, "data-cy": "text", color: color, fontSize: fontSize }, children));
};
exports.RichContentText = RichContentText;
